import React from 'react';
import { useUser } from '../../../hooks';
import { Alert, Col, Row } from 'react-bootstrap';

export const LoggedOutAlert = () => {
    const { isUserAuthenticated } = useUser();

    return (
        <>
            {!isUserAuthenticated && (
                <Row className={'d-flex justify-content-center my-2'}>
                    <Col md={6} className={''}>
                        <Alert variant={'warning'} className={'font-18 text-primary'}>
                            <i className='mdi mdi-account-alert-outline me-2' />
                            <span>Nu ești autentificat, unele funcționalități ale platformei vor fi limitate</span>
                        </Alert>
                    </Col>
                </Row>
            )}
        </>
    );
};
